import React from "react";

const Logo = props => (
  <svg width={508} height={71} viewBox="0 0 508 71" {...props}>
    <title>Abriohealth</title>
    <defs>
      <path id="prefix__a" d="M.75.898h212.241V70.94H.75z" />
      <path id="prefix__c" d="M.06.335h236.384v49.472H.06z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(243)">
        <mask id="prefix__b" fill="#fff">
          <use xlinkHref="#prefix__a" />
        </mask>
        <path
          d="M.75.898h12.327v28.059h.184c3.129-4.6 8.465-7.543 14.904-7.543 11.223 0 16.099 7.911 16.099 18.582v29.898H31.937V44.596c0-5.795-.092-13.616-8.004-13.616-8.924 0-10.856 9.661-10.856 15.733v23.181H.75V.898M86.676 41.561c-.368-5.981-3.128-11.131-10.028-11.131-6.899 0-10.395 4.783-10.947 11.131h20.975zm8.28 25.666C90.448 69.711 85.296 71 78.673 71c-15.64 0-24.747-9.016-24.747-24.564 0-13.708 7.267-25.022 21.987-25.022 17.57 0 22.538 12.051 22.538 28.609h-32.75c.552 7.637 5.888 11.961 13.523 11.961 5.98 0 11.132-2.209 15.732-4.785v10.028zM124.673 61.984c3.771 0 6.715-1.656 8.646-4.232 2.025-2.668 2.577-6.072 2.577-9.752h-5.336c-5.52 0-13.707.92-13.707 8.187 0 4.049 3.404 5.797 7.82 5.797zm-14.444-36.983c4.784-2.208 11.223-3.587 16.467-3.587 14.444 0 20.423 5.979 20.423 19.963v6.072c0 4.783.093 8.371.185 11.867.092 3.588.275 6.899.551 10.578H137c-.46-2.482-.46-5.611-.552-7.082h-.184C133.412 68.055 127.249 71 121.637 71c-8.372 0-16.56-5.061-16.56-14.076 0-7.084 3.404-11.223 8.096-13.524 4.691-2.298 10.764-2.759 15.916-2.759h6.807c0-7.636-3.404-10.211-10.671-10.211-5.245 0-10.488 2.023-14.628 5.15l-.368-10.579zM159.541 69.894h12.327V.898h-12.327zM188.89 31.533h-9.108v-9.015h9.108v-9.476l12.326-3.956v13.432h10.948v9.015h-10.948v22.078c0 4.049 1.104 7.821 5.797 7.821 2.207 0 4.323-.459 5.611-1.288l.367 9.75c-2.575.737-5.428 1.106-9.107 1.106-9.659 0-14.994-5.981-14.994-15.363V31.533"
          fill="#867C70"
          mask="url(#prefix__b)"
        />
      </g>
      <path
        d="M463.628.898h12.328v28.059h.184c3.128-4.6 8.464-7.543 14.903-7.543 11.224 0 16.099 7.911 16.099 18.582v29.898h-12.327V44.596c0-5.795-.092-13.616-8.003-13.616-8.924 0-10.856 9.661-10.856 15.733v23.181h-12.328V.898"
        fill="#867C70"
      />
      <path
        d="M29.408 41.791h9.136l-4.569-11.416-4.567 11.416zm-.191-38.534h9.515l26.641 66.596H49.769l-5.9-14.742H24.083l-5.9 14.742H2.579L29.217 3.257z"
        fill="#4CBABE"
      />
      <path
        d="M104.48 46.072c0-9.135-4.378-11.417-8.564-11.417-3.71 0-6.47.857-8.561 1.81v19.121c2.188 1.049 4.948 1.902 8.561 1.902 4.186 0 8.564-2.283 8.564-11.416zm14.744 0c0 14.272-9.894 24.735-23.308 24.735-3.427 0-6.276-.473-8.561-1.233v.279H73.08V3.257h14.275v19.412c2.285-.763 5.134-1.334 8.561-1.334 13.414 0 23.308 10.468 23.308 24.737z"
        fill="#FAD633"
      />
      <path
        d="M128.742 69.853V22.287h14.268v.189c1.715-.665 3.617-1.141 5.712-1.141 3.424 0 6.373.762 8.752 1.619l-8.091 12.271c-2.279-.474-3.994-.57-6.373 1.142v33.486h-14.268"
        fill="#E6832D"
      />
      <path
        d="M174.316 69.853c-6.947 0-10.466-5.322-10.466-10.748V22.287h14.27v31.969c0 2.949 1.14 3.613 3.046 3.613v11.984h-6.85zM162.898 8.869c0-4.374 3.709-7.989 7.989-7.989 4.567 0 8.185 3.615 8.185 7.989 0 4.473-3.618 8.185-8.185 8.185-4.28 0-7.989-3.712-7.989-8.185z"
        fill="#4CBABE"
      />
      <g transform="translate(0 21)">
        <mask id="prefix__d" fill="#fff">
          <use xlinkHref="#prefix__c" />
        </mask>
        <path
          d="M221.695 25.072c0-9.135-4.376-11.417-8.559-11.417-4.19 0-8.564 2.282-8.564 11.417 0 9.133 4.374 11.416 8.564 11.416 4.183 0 8.559-2.283 8.559-11.416zm14.749 0c0 14.272-9.894 24.735-23.308 24.735-13.418 0-23.312-10.463-23.312-24.735 0-14.269 9.894-24.737 23.312-24.737 13.414 0 23.308 10.468 23.308 24.737zM0 48.869h3.211l2.203-5.967h-.489C2.201 47.033 0 48.869 0 48.869"
          fill="#D73D6F"
          mask="url(#prefix__d)"
        />
      </g>
      <path
        fill="#D73D6F"
        d="M26.638 3.272l-3.043 7.614 1.493 3.733 4.467-11.347h-2.917M39.117 42.045l-5.234-12.688-1.472 3.57 3.646 9.118h3.06M41.036 54.479l6.154 15.39 3.379-.016-6.25-15.374h-3.283"
      />
      <path
        d="M88.579 70.541a32.78 32.78 0 0 0 4.189.281c.554 0 1.099-.019 1.639-.051-.649-.027.523-.393.523-.393l-5.125-.442s-.456.211-.555.189c-.224.139-.443.289-.671.416"
        fill="#48BABE"
      />
      <path
        fill="#4CBABE"
        d="M70.501 69.869h3.007V3.272h-3.007zM99.869 56.609c.132-.067.386.529.514.452 2.386-1.431 4.609-5.128 4.609-10.971 0-5.736-2.225-9.504-4.547-10.967-.17-.107-.401.531-.577.44 1.291 3.347 2.033 6.947 2.033 10.523 0 3.578-.742 7.176-2.032 10.523M92.768 21.351c-1.333 0-2.763.091-4.189.285.26.146.511.315.766.474.128-.031.423.222.553.192 1.158-.258 3.906-.62 5.282-.726.311-.024-1.012-.154-.69-.169a29.54 29.54 0 0 0-1.722-.056M126.163 69.869h3.22V22.302h-3.22zM146.524 21.351c-1.334 0-2.664.091-4.093.476.298.169.574.359.836.56.124-.046.38.264.506.22.884-.304 3.553-.83 4.532-.984.406-.063-1.048-.187-.625-.217-.386-.019-.769-.055-1.156-.055"
      />
      <path
        d="M146.866 34.717l-.062.523.344-.523c-.052 0-.229-.002-.282 0"
        fill="#48BABE"
      />
      <path
        d="M164.487 59.122l-.02-36.82h-3.196v36.817c0 5.428 3.518 10.75 10.466 10.75h2.537c-.291 0 .115-.5-.162-.518-6.328-.418-9.625-5.029-9.625-10.229M169.435 1.034a4.02 4.02 0 0 0-1.03-.139c-2.14 0-3.57 1.578-4.32 3.815.079-.125-.06.491.025.371 1.148-1.619 3.757-3.35 5.711-3.792.094-.022-.481-.237-.386-.255M164.11 13.198c.757 2.253 2.179 3.871 4.295 3.871.36 0 .698-.055 1.022-.144-.214-.041.612-.286.404-.345-1.711-.488-4.651-2.438-5.721-3.875-.138-.186.123.69 0 .493"
        fill="#FAD633"
      />
      <path
        d="M222.367 46.096c0-4.381-1.264-7.663-2.89-9.395-.184-.194-.691.105-.873-.064.336 3.025.512 6.193.512 9.355 0 3.25-.181 6.485-.53 9.563.184-.169.877.123 1.062-.073 1.634-1.728 2.719-4.994 2.719-9.386M190.523 46.094c0-11.463 5.641-20.043 15.11-23.143.118-.039.241-.513.36-.55.123-.26.246-.521.374-.765-11.224 1.997-19.122 11.704-19.122 24.45 0 12.752 7.898 22.455 19.122 24.357-.108-.209-.211-.433-.315-.654-.147-.045-.29-.634-.435-.682-9.433-3.105-15.094-11.556-15.094-23.013"
        fill="#4CBABE"
      />
      <path
        d="M10.561 52.459C8.776 57.4 6.735 61.154 4.925 63.902l-2.387 5.967h13.066s-6.752-4.846-5.043-17.41M29.176 3.272l-4.314 10.784 7.803 19.506 1.269-3.171 4.568 11.416h-2.54l1.331 3.328H16.746l-.761 1.902h22.074l3.235 8.088h2.533l5.9 14.744h13.067L36.153 3.272h-6.977"
        fill="#5E364F"
      />
      <path fill="#6CA14D" d="M73.038 69.869h11.738V3.272H73.038z" />
      <path
        fill="#6B6C36"
        d="M128.7 69.869h11.731V22.302H128.7zM147.68 21.406c-1.586.115-3.058.48-4.413.981 4.39 3.373 3.757 10.989 3.574 12.562.053-.002.105-.006.158-.006l7.896-11.974c-2.15-.911-4.661-1.434-7.215-1.563"
      />
      <path
        d="M164.11 13.198c1.19 1.908 3.119 3.301 5.317 3.727 2.677-.73 4.119-4.303 4.119-8.041 0-3.727-1.44-7.149-4.111-7.85-2.217.417-4.161 1.791-5.35 3.676-.416 1.241-.626 2.682-.626 4.174 0 1.526.218 3.024.651 4.314M163.808 22.302v36.817c0 5.428 3.519 10.75 10.466 10.75h1.268V22.302h-11.734"
        fill="#6CA14D"
      />
      <path
        d="M214.739 21.636c1.896 3.602 3.2 9.013 3.865 15.001 1.797 1.666 3.049 4.576 3.049 9.449 0 4.891-1.259 7.805-3.067 9.469-.671 5.927-1.968 11.256-3.847 14.888 11.227-1.902 19.126-11.605 19.126-24.357 0-12.746-7.899-22.453-19.126-24.45M205.993 22.401c-9.664 2.99-16.211 12.079-16.211 23.685 0 11.633 6.574 20.734 16.27 23.703-2.647-5.588-4.059-14.645-4.059-23.797 0-8.996 1.391-18.069 4-23.591"
        fill="#5E364F"
      />
      <path
        d="M116.646 46.086c0-13.961-8.842-23.89-22.156-24.679-1.905.09-3.63.337-5.145.703 4.543 2.841 8.334 7.773 10.523 13.453 2.578 1.331 4.57 4.367 4.57 10.523s-1.991 9.193-4.569 10.523c-2.204 5.721-6.032 10.682-10.619 13.516 1.517.35 3.247.566 5.157.646 13.361-.751 22.239-10.693 22.239-24.685"
        fill="#6CA14D"
      />
    </g>
  </svg>
);

export default Logo;
